import "./style.scss";

import { SearchOutlined } from "@ant-design/icons";
import { Input as AntdInput, InputProps } from "antd";
import { SizeType } from "antd/es/config-provider/SizeContext";
import * as React from "react";

import { SizeEnum } from "@/types";

let searchTimeout: ReturnType<typeof setTimeout> | null;

interface SearchInputProps extends Omit<InputProps, "onChange" | "size"> {
  debounceTime?: number;
  initialValue?: string;
  clearSearchText?: boolean;
  onChange: (val: string) => void;
  size?: SizeEnum;
}

export const SearchInput = ({
  size = SizeEnum.large,
  placeholder,
  initialValue = "",
  clearSearchText = false,
  onChange,
  debounceTime = 800,
  ...rest
}: SearchInputProps) => {
  const [value, setValue] = React.useState<string>("");

  React.useEffect(() => {
    if (initialValue) {
      setValue(initialValue);
      onChange(initialValue);
    }
  }, [initialValue]);

  React.useEffect(() => {
    clearSearchText && setValue("");
  }, [clearSearchText]);

  React.useEffect(() => {
    return () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
        searchTimeout = null;
      }
    };
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);

    if (searchTimeout) {
      clearTimeout(searchTimeout);
      searchTimeout = null;
    }

    if (!e.target.value) {
      onChange("");
    } else {
      searchTimeout = setTimeout(
        () =>
          onChange(
            encodeURIComponent(e.target.value.split("'").join("''")).split("%20").join(
              " "
            )
          ),
        debounceTime
      );
    }
  };

  return (
    <div className="search_input_wrapper">
      <AntdInput
        size={size as SizeType}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        prefix={<SearchOutlined />}
        allowClear
        className="placeholder:text-sm "
        {...rest}
      />
    </div>
  );
};
